export default __webpack_public_path__ + "media/zurb/img/events/wired/sacred-heart/sacred-heart-img2-c3f1fb3f4858e4453a1b07e07fec7899.jpg";